import React, { Suspense, lazy } from "react";
import type { Agent } from "./AgentListView";
import type { AgentDetails } from "./hooks/useTeamsContext";

const AgentMonitoringViewContent = lazy(() => import("./AgentMonitoringViewContent"));

export interface AgentMonitoringViewProps {
  selectedAgent: Agent;
  appId: string | null;
  agentDetailsList?: AgentDetails[];
  selectedAgentDetailKey?: string | null;
  onAgentDetailSelect?: (detailKey: string) => void;
}

/**
 * Lazy wrapper so @loops-webv2/ui (UiCard) is only loaded when this view is shown.
 * Prevents "Cannot access '__WEBPACK_DEFAULT_EXPORT__' before initialization" at app bootstrap.
 */
const AgentMonitoringView: React.FC<AgentMonitoringViewProps> = ({
  selectedAgent,
  appId,
  agentDetailsList = [],
  selectedAgentDetailKey,
  onAgentDetailSelect,
}) => {
  return (
    <Suspense
      fallback={
        <div style={{ padding: 24, textAlign: "center" }}>Loading…</div>
      }
    >
      <AgentMonitoringViewContent
        selectedAgent={selectedAgent}
        appId={appId}
        agentDetailsList={agentDetailsList}
        selectedAgentDetailKey={selectedAgentDetailKey}
        onAgentDetailSelect={onAgentDetailSelect}
      />
    </Suspense>
  );
};

export default AgentMonitoringView;
